import * as dataLayerConstants from '../../../analytics/src/datalayer/constants';
import initContentReadingTracking from '../../../analytics/src/datalayer-content-reading-tracking';
import removeArticleAds from '../helpers/remove-article-ads';

export const inlinePayWallDisplayed = messageParts => {
	const paywallElement = document.querySelector( '#subscription-barrier' );
	const paywallElementFrame = paywallElement.querySelector( window.PIANO_MESSAGE_ORIGIN_SELECTOR );
	if ( window.PIANO_MESSAGE_ORIGIN_SELECTOR ) {
		const baseUrl = `${top.location.origin}${top.location.pathname}`;
		const targetPath = new URL( baseUrl );
		( async () => {
			try {
				// Wait for both RTA readiness AND paywall display
				const rtaId = ( await RTA.ids ).user;

				targetPath.searchParams.set( 'rtaId', rtaId );

				if ( paywallElementFrame ) {
					paywallElementFrame.contentWindow.postMessage(
						'paywall-wall-target-path|' + targetPath.toString(),
						window.PIANO_MESSAGE_ORIGIN,
					);
				}
			} catch ( err ) {
				console.error( "RTA user id didn't load:", err );
			}
		} )();
	}

	removeArticleAds();

	window.dataLayer = window.dataLayer || [];

	if ( window.dataLayer ) {
		const paywallIdentifier = 'paywallImpression1';

		const paywallImpressionObject = {};
		paywallImpressionObject.event = paywallIdentifier;
		paywallImpressionObject[ `event_action_${paywallIdentifier}` ] = 'impression';
		paywallImpressionObject[ `event_label_${paywallIdentifier}` ] = messageParts[ 1 ];
		paywallImpressionObject[ `service_platform_${paywallIdentifier}` ] =
			dataLayerConstants.SERVICE_PLATFORM_PIANO;
		paywallImpressionObject.piano_label = messageParts[ 1 ];

		window.dataLayer.push( paywallImpressionObject );
	}

	window.paywallDisplayed = 'Subscription';

	const payWallDisplayed = new CustomEvent( 'payWallDisplayed' );
	window.dispatchEvent( payWallDisplayed );

	initContentReadingTracking();
};

export default inlinePayWallDisplayed;
